import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const hi: AppStrings = {
  // COMMON
  error_title: 'त्रुटि',
  cancel: 'रद्द करें',
  retry: 'फिर कोशिश करें',
  back_arrow: '← वापस',

  // ASK SCREEN
  ask_box_unavailable: 'बॉक्स उपलब्ध नहीं',
  ask_box_unavailable_desc: 'लिंक पुराना हो सकता है या मालिक ने बॉक्स बंद कर दिया है।',
  ask_create_own_box: 'अपना बॉक्स बनाएं',
  ask_sent_title: 'भेज दिया ✅',
  ask_sent_desc: 'तुम्हारा गुमनाम सवाल बॉक्स के मालिक तक पहुंच गया।',
  ask_anonymous_hint: 'तुम्हारा सवाल गुमनाम तरीके से भेजा जाएगा।',
  ask_placeholder: 'अपना सवाल लिखो…',
  ask_send: 'भेजें',
  ask_sending: 'भेजा जा रहा है…',
  ask_error_rate_limit: 'बहुत ज़्यादा अनुरोध — एक मिनट रुको।',
  ask_error_restart: 'कृपया Mini App को फिर से शुरू करें।',
  ask_error_load: 'बॉक्स लोड नहीं हो सका।',
  ask_error_send: 'सवाल नहीं भेजा जा सका।',
  ask_error_banned: 'तुम्हें ऐप में ब्लॉक कर दिया गया है।',
  ask_banned_appeal_btn: 'अपील करें',
  ask_appeal_sent: 'अपील भेज दी गई। हम इसे मैन्युअली देखेंगे।',

  // AGE GATE
  age_gate_title: 'केवल 18+ के लिए',
  age_gate_desc:
    'तुम एक गुमनाम सवाल भेज रहे हो। सम्मानजनक रहो: उत्पीड़न, धमकियां, नाबालिगों से जुड़ी यौन सामग्री और कानून का उल्लंघन करने वाली कोई भी सामग्री प्रतिबंधित है। गुमनामी का मतलब सज़ा से मुक्ति नहीं है — उल्लंघन मॉडरेशन को रिपोर्ट किए जाते हैं। सवाल भेजकर तुम पुष्टि करते हो कि तुम 18+ हो और नियम मानते हो।',
  age_gate_confirm: 'मैं 18+ हूं — जारी रखें',

  // INBOX SCREEN
  inbox_title: 'तुम्हारा बॉक्स',
  box_link_accordion: 'आमंत्रण लिंक',
  inbox_notifications_ask: '🔔 क्या बॉट को नए सवालों की सूचना भेजने दें?',
  inbox_notifications_allow: 'अनुमति दें',
  inbox_notifications_dismiss_label: 'बंद करें',
  inbox_box_toggle_disable: 'सवाल बंद करें',
  inbox_box_toggle_enable: 'सवाल चालू करें',
  inbox_box_disabled_warning: 'सवाल बंद हैं — कोई नया सवाल स्वीकार नहीं किया जाएगा।',
  inbox_share_hint: 'लिंक शेयर करो ताकि दोस्त तुमसे गुमनाम सवाल पूछ सकें।',
  inbox_copy: 'कॉपी करें',
  inbox_copied: 'कॉपी हो गया',
  inbox_copy_error: 'त्रुटि',
  inbox_no_deeplink: 'डिप्लॉय के बाद लिंक दिखेगा।',
  inbox_invite_story: 'Story के ज़रिए आमंत्रित करें',
  inbox_invite_chat: 'चैट के ज़रिए आमंत्रित करें',
  inbox_card_rendering: 'आमंत्रण कार्ड अभी बन रहा है।',
  inbox_story_unsupported:
    'इस Telegram संस्करण में Story उपलब्ध नहीं है। "चैट के ज़रिए" आज़माओ।',
  inbox_story_error: 'Story खोलने में विफल।',
  inbox_chat_unsupported:
    'इस Telegram संस्करण में चैट शेयरिंग उपलब्ध नहीं है। ऐप अपडेट करो।',
  inbox_chat_error: 'शेयर नहीं हो सका। फिर कोशिश करो।',
  inbox_chat_prepare_error: 'आमंत्रण तैयार नहीं हो सका।',
  inbox_filter_incoming: 'आने वाले',
  inbox_filter_hidden: 'छुपे हुए',
  inbox_filter_blocked: 'ब्लॉक किए',
  inbox_filter_empty: 'अभी यहां कुछ नहीं है।',
  inbox_acc_unanswered: 'अनुत्तरित',
  inbox_acc_answered: 'उत्तरित',
  inbox_acc_hidden: 'छुपे हुए',
  inbox_acc_blocked: 'ब्लॉक किए',
  inbox_empty: 'अभी कोई सवाल नहीं। ऊपर दिया लिंक शेयर करो।',
  inbox_load_more: 'और लोड करें',
  inbox_load_more_error: 'अगला पेज लोड नहीं हो सका।',
  inbox_error_load: 'बॉक्स लोड नहीं हो सका।',
  inbox_rate_limit: 'बहुत ज़्यादा अनुरोध — एक मिनट रुको।',
  inbox_toggle_error: 'बॉक्स की स्थिति नहीं बदली जा सकी।',

  // MESSAGE BOX (Трек D)
  message_tagline: 'मुझे गुमनाम तरीके से लिखो',
  message_placeholder: 'संदेश लिखो…',
  message_anonymous_hint: 'तुम्हारा संदेश गुमनाम तरीके से भेजा जाएगा।',
  message_sent_title: 'भेज दिया ✅',
  message_sent_desc: 'तुम्हारा गुमनाम संदेश पहुंचा दिया गया है।',
  message_owner_entry: 'मुझे लिखो',
  message_share_hint: 'लिंक शेयर करो ताकि कोई भी तुम्हें गुमनाम संदेश भेज सके।',
  message_inbox_open: 'प्राप्त संदेश',
  message_inbox_title: 'संदेश',
  message_inbox_empty: 'अभी कोई संदेश नहीं। ऊपर दिया अपना लिंक शेयर करो।',

  // ANSWER SCREEN
  answer_title: 'सवाल का जवाब दो',
  answer_placeholder: 'अपना जवाब लिखो…',
  answer_submit: 'भेजें',
  answer_submitting: 'भेजा जा रहा है…',
  answer_back: 'वापस',
  answer_error_send: 'जवाब नहीं भेजा जा सका।',

  // SHARE SCREEN
  share_title: 'जवाब प्रकाशित हो गया ✅',
  share_hint: 'कार्ड शेयर करो और और भी सवाल इकट्ठा करो।',
  share_card_rendering_desc:
    'कार्ड अभी बन रहा है। सवालों पर वापस जाओ और थोड़ी देर बाद चेक करो — तब Story या चैट में शेयर कर सकते हो।',
  share_card_alt: 'जवाब कार्ड',
  share_story_btn: 'Story में शेयर करें',
  share_story_btn_busy: 'खुल रहा है…',
  share_chat_btn: 'चैट में शेयर करें',
  share_chat_btn_busy: 'तैयार हो रहा है…',
  share_back: 'सवालों पर वापस जाएं',
  share_story_unsupported:
    'इस Telegram संस्करण में Story उपलब्ध नहीं है। "चैट में शेयर करें" आज़माओ।',
  share_story_error: 'Story खोलने में विफल। "चैट में शेयर करें" आज़माओ।',
  share_chat_sent: 'संदेश भेज दिया गया।',
  share_chat_unsupported:
    'इस Telegram संस्करण में चैट शेयरिंग उपलब्ध नहीं है। ऐप अपडेट करो।',
  share_chat_error: 'शेयर नहीं हो सका। फिर कोशिश करो।',
  share_chat_prepare_error: 'संदेश तैयार नहीं हो सका।',

  // LEADERBOARD SCREEN
  lb_title: 'लीडरबोर्ड',
  lb_period_7d: '7 दिन',
  lb_period_30d: '30 दिन',
  lb_period_all: 'सभी समय',
  lb_group_label: 'श्रेणी',
  lb_group_all: 'सभी',
  lb_group_ask: 'पूछो',
  lb_group_rate: 'रेट करो',
  lb_group_confession: 'इकरार',
  lb_group_guesswho: 'अंदाज़ा लगाओ कौन',
  lb_group_message: 'संदेश',
  lb_error: 'लीडरबोर्ड लोड नहीं हो सका',
  lb_empty: 'अभी रैंकिंग में कोई नहीं',
  lb_anon: 'गुमनाम',
  lb_load_more: 'और लोड करें',
  lb_questions: (n) =>
    plural('hi', n, {
      one: '{n} सवाल',
      other: '{n} सवाल',
    }),
  lb_referrals: (n) =>
    plural('hi', n, {
      one: '{n} रेफरल',
      other: '{n} रेफरल',
    }),

  // REWARDS SCREEN
  rw_title: 'मेरे पुरस्कार',
  rw_error: 'पुरस्कार लोड नहीं हो सके',
  rw_level: (n) => `स्तर ${n}`,
  rw_confirmed_referrals: (n) =>
    plural('hi', n, {
      one: '{n} पुष्ट रेफरल',
      other: '{n} पुष्ट रेफरल',
    }),
  rw_next_level_section: (n) =>
    plural('hi', n, {
      one: 'अगला स्तर — {n} रेफरल',
      other: 'अगला स्तर — {n} रेफरल',
    }),
  rw_to_level: (level, target) => `स्तर ${level} तक: ${target}`,
  rw_max_level: 'अधिकतम स्तर पर पहुंच गए!',
  rw_badges_section: 'बैज',
  rw_formats_section: 'बॉक्स फॉर्मेट',

  // QUESTION CARD
  qcard_status_new: 'नया',
  qcard_status_hidden: 'छुपा हुआ',
  qcard_status_answered: 'उत्तरित',
  qcard_moderation_flagged: 'सावधान: संदिग्ध संदेश',
  qcard_answer_btn: 'जवाब दो',
  qcard_answer_send: 'भेजें',
  qcard_share_btn: 'शेयर करें',
  qcard_hide_btn: 'छुपाओ',
  qcard_show_btn: 'दिखाओ',
  qcard_report_btn: 'रिपोर्ट करें',
  qcard_block_btn: 'ब्लॉक करें',
  qcard_unblock_btn: 'अनब्लॉक करें',
  qcard_report_reason_label: 'रिपोर्ट का कारण चुनें:',
  qcard_reason_spam: 'स्पैम',
  qcard_reason_harassment: 'उत्पीड़न',
  qcard_reason_sexual: 'यौन सामग्री',
  qcard_reason_other: 'अन्य',
  qcard_error_hide: 'दृश्यता बदली नहीं जा सकी।',
  qcard_error_report: 'रिपोर्ट नहीं भेजी जा सकी।',
  qcard_error_block: 'भेजने वाले को ब्लॉक नहीं किया जा सका।',
  qcard_report_done: 'रिपोर्ट भेज दी गई — धन्यवाद।',
  qcard_block_done: 'भेजने वाला ब्लॉक हो गया।',
  qcard_unblock_done: 'भेजने वाला अनब्लॉक हो गया।',

  // ERRORS
  err_network: 'सर्वर से कनेक्शन नहीं है। इंटरनेट चेक करो और फिर कोशिश करो।',
  err_server_unavailable: 'सर्वर अभी अनुपलब्ध है, बाद में फिर कोशिश करो।',
  err_internal: 'हमारी तरफ से कुछ गड़बड़ हो गई। हम देख रहे हैं — बाद में कोशिश करो।',
  err_bad_request: 'कृपया दर्ज किए गए डेटा की जांच करो।',
  err_generic: 'कार्रवाई पूरी नहीं हो सकी, बाद में कोशिश करो।',
  err_schema: 'डेटा त्रुटि। ऐप अपडेट करने की कोशिश करो।',
  share_story_link_premium_note:
    'Story में क्लिक करने योग्य लिंक के लिए Telegram Premium चाहिए। इसके बिना भी दोस्त तुम्हें ढूंढ सकते हैं — कार्ड पर तुम्हारा यूज़रनेम दिखता है।',

  // AUTH ERROR SCREEN
  auth_error_title: 'पहुंच त्रुटि',
  auth_error_desc:
    'प्रमाणीकरण विफल हुआ। कृपया Telegram से Mini App बंद करके फिर से खोलो।',

  // REWARD TOAST
  reward_toast_title: 'नया पुरस्कार!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'सवाल',
  tab_leaderboard: 'लीडरबोर्ड',
  tab_rewards: 'पुरस्कार',
  tab_settings: 'सेटिंग',

  // SETTINGS SCREEN
  settings_title: 'सेटिंग',
  settings_section_general: 'सामान्य',
  settings_notifications: 'नए सवालों की सूचनाएं',
  settings_notifications_hint: 'जब कोई सवाल पूछेगा तो बॉट तुम्हें संदेश भेजेगा।',
  settings_notifications_error: 'सूचना सेटिंग सहेजी नहीं जा सकी।',
  settings_language: 'भाषा',
  settings_language_error: 'भाषा नहीं बदली जा सकी। फिर कोशिश करो।',
  settings_section_about: 'बारे में',
  settings_version: 'संस्करण',

  // CODE ENTRY
  code_modal_title: 'Story लिंक केवल Premium के लिए',
  code_modal_explain:
    'Telegram Story में क्लिक करने योग्य लिंक केवल Premium सदस्यों को देता है। इसके बजाय Story में अपना कोड जोड़ो — आगंतुक ऐप में टाइप करेंगे और गुमनाम सवाल पूछेंगे।',
  code_modal_your_code: 'तुम्हारा कोड',
  code_modal_copy: 'कोड कॉपी करें',
  code_modal_copied: 'कॉपी हो गया',
  code_modal_share_btn: 'Story में शेयर करें',
  code_modal_loading: 'तुम्हारा कोड मिल रहा है…',
  code_modal_error: 'तुम्हारा कोड नहीं मिला। बाद में कोशिश करो।',
  ask_code_title: 'कोड दर्ज करें',
  ask_code_desc:
    'Story से आए? उसमें कोड ढूंढो (जैसे 1234) और नीचे टाइप करो।',
  ask_code_placeholder: 'Story का कोड',
  ask_code_find: 'खोजें',
  ask_code_not_found: 'कोड नहीं मिला। अंक जांचो और फिर कोशिश करो।',
  ask_code_invalid: 'कोड 4 अंकों का होता है।',
  code_onboarding_header: 'Story से आए?',
  code_onboarding_text: 'दोस्त का कोड दर्ज करो उनसे गुमनाम सवाल पूछने के लिए।',
  code_onboarding_action: 'कोड दर्ज करें',
  settings_ask_by_code: 'कोड से पूछो',
  settings_my_code_title: 'तुम्हारा Story कोड',
  settings_my_code_hint:
    'यह कोड अपनी Story में लिखो — आगंतुक इसे टाइप करेंगे और गुमनाम सवाल पूछेंगे। Telegram Story में क्लिक करने योग्य लिंक केवल Premium सदस्यों को देता है।',
  settings_my_code_rotate: 'नया कोड पाओ',
  settings_my_code_rotating: 'अपडेट हो रहा है…',
  settings_my_code_done: 'कोड अपडेट हो गया',
  settings_my_code_error: 'तुम्हारा कोड नहीं मिला।',
  settings_my_code_rotate_confirm_title: 'कोड बदलें?',
  settings_my_code_rotate_confirm_desc:
    'तुम्हारा पुराना कोड तुरंत काम करना बंद कर देगा। जिन्होंने उसे तुम्हारी Story में देखा था, वे तुम तक नहीं पहुँच पाएँगे। इसे तभी बदलो जब कोई तुम्हें परेशान कर रहा हो।',
  settings_my_code_rotate_confirm_action: 'कोड बदलो',

  // BOT
  bot_greeting: (name) => (name ? `नमस्ते, ${name}! 👋` : 'नमस्ते! 👋'),
  bot_onboarding:
    'यह है VeylMe — गुमनाम सवाल।\n\n' +
    'Mini App खोलो, अपनी Story में «मुझसे गुमनाम पूछो» कार्ड शेयर करो — ' +
    'और गुमनाम सवाल सीधे यहाँ पाओ।\n\n' +
    '⚠️ 18+. सम्मान बनाए रखो: धमकी, बदमाशी और प्रतिबंधित सामग्री ' +
    'की अनुमति नहीं है। गुमनामी ≠ दण्ड से मुक्ति — उल्लंघन मॉडरेशन को भेजे जाते हैं।',
  bot_open_btn: 'VeylMe खोलो',
  notify_answer_btn: 'जवाब दें',
  bot_invite_text:
    'किसी ने VeylMe लिंक शेयर किया।\n\n' +
    'गुमनाम सवाल पूछने के लिए Mini App खोलो:',
  bot_invite_btn: 'गुमनाम पूछो',

  // WORK-027 i18n sweep
  tagline: 'मुझसे गुमनाम सवाल पूछो',
  share_ask_action: 'पूछो',
  share_answered_text: 'मैंने एक गुमनाम सवाल का जवाब दिया 👀',
  err_not_in_telegram: 'Mini App Telegram में नहीं चल रहा। कृपया ऐप को फिर से शुरू करो।',
  badge_viral_starter: 'वायरल शुरुआत',
  badge_storyteller: 'कहानीकार',
  badge_loop_master: 'लूप मास्टर',
  theme_confession: 'इकरार',
  theme_guesswho: 'अंदाज़ा लगाओ कौन',
  rw_format_named: (name) => `फॉर्मेट «${name}»`,
  card_label_question: 'सवाल',
  card_label_answer: 'जवाब',
  card_invite_subtitle: 'गुमनाम, बिना साइन-अप के',
  card_code_hint: 'ऐप में कोड डालो',
  share_msg_title: (brand) => `${brand} · गुमनाम सवाल`,
  notify_new_question: '🔔 किसी ने आपसे एक गुमनाम सवाल पूछा',
  notify_unanswered_reminder: (n) =>
    plural('hi', n, {
      one: '🔔 आपका {n} सवाल अनुत्तरित है',
      other: '🔔 आपके {n} सवाल अनुत्तरित हैं',
    }),
  notify_ban_permanent: 'हमेशा के लिए',
  notify_ban_until: (date) => `${date} तक`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ तुम्हें VeylMe में ${untilPhrase} ब्लॉक कर दिया गया है। बहुत सारे प्राप्तकर्ताओं ने तुम्हारे संदेशों की शिकायत की।\nअगर तुम्हें लगता है कि यह गलती है, तो ऐप में अपील भेज सकते हो।`,
  notify_warning_msg:
    '⚠️ कई प्राप्तकर्ताओं ने तुम्हारे संदेशों की शिकायत की है। थोड़ा और, और तुम VeylMe में ब्लॉक हो जाओगे।',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'मेरे सवाल',
  my_questions_empty_title: 'तुमने अभी तक कोई सवाल नहीं पूछा',
  my_questions_empty_desc: 'किसी के बॉक्स में सवाल पूछो — जवाब यहाँ दिखेगा।',
  my_questions_loading: 'जवाब जाँचा जा रहा है…',
  my_questions_waiting: 'जवाब का इंतज़ार है',
  my_questions_answer_label: 'जवाब',
  settings_my_questions: 'मेरे सवाल',
  ask_sent_find_reply_hint: 'जवाब बाद में «मेरे सवाल» में मिल जाएगा।',
  inbox_story_nonpremium_hint: 'Telegram Premium के बिना Story लिंक क्लिक करने लायक नहीं होती, इसलिए कोड दिखाया जाता है — चैट में शेयर करना ज़्यादा भरोसेमंद है।',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Telegram का पास पुराना हो गया',
  session_expired_desc: 'Telegram ऐप को पास सिर्फ़ एक बार, शुरू होते समय देता है, और यह वाला पुराना हो चुका है। ऐप दोबारा खोलो — जो टेक्स्ट तुमने शुरू किया था, वह हमने सहेज लिया है।',
  session_expired_desc_no_storage: 'Telegram का पास पुराना हो चुका है, ऐप को दोबारा खोलना होगा। जो टेक्स्ट तुमने लिखा था उसे सहेज नहीं पाए — जाने से पहले उसे कॉपी कर लो।',
  session_expired_reopen: 'दोबारा खोलो',
  session_expired_stuck_title: 'Telegram ने वही पुराना पास लौटा दिया',
  session_expired_stuck_desc: 'बॉट के मेन्यू से ऐप को पूरी तरह बंद करो और फिर से खोलो — तब Telegram नया पास देगा।',
  session_auth_failed_title: 'लॉगिन की पुष्टि नहीं हो सकी',
  session_auth_failed_desc: 'Telegram ने ऐप में तुम्हारे लॉगिन की पुष्टि नहीं की। ऐप बंद करो और बॉट वाली चैट से इसे दोबारा खोलो।',
  session_expired_manual_close: 'ऐप यहाँ से खुद को बंद नहीं कर सकता — इसे खुद बंद करो और बॉट वाली चैट से दोबारा खोलो।',
  session_expiring_soon: 'Telegram का पास जल्द ख़त्म हो जाएगा। कुछ भी न खोए, इसलिए ऐप दोबारा खोलो।',
  my_questions_check_failed: 'जवाब जाँचे नहीं जा सके। बाद में कोशिश करो।',
  settings_notifications_load_error: 'सेटिंग लोड नहीं हो सकी।',
};
